<div class="generic-upload">
  <input
    #fileInput
    type="file"
    [id]="inputId"
    [multiple]="multiple"
    [accept]="restrictions.allowedExtensions?.join(',')"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    class="generic-upload__file-input"
    [attr.aria-label]="resolvedTranslations.labels.selectFiles"
  />

  <div
    class="generic-upload__drop-zone"
    [class.generic-upload__drop-zone--drag-over]="isDragOver"
    [class.generic-upload__drop-zone--disabled]="disabled"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="selectFiles()"
    (keydown)="onKeyDown($event)"
    role="button"
    [attr.aria-label]="resolvedTranslations.labels.dropZone"
    [attr.aria-disabled]="disabled"
    tabindex="0">
    
    <div class="generic-upload__select-row">
      <button
        type="button"
        class="generic-button"
        [disabled]="disabled"
        (click)="selectFiles(); $event.stopPropagation();"
        [attr.aria-label]="resolvedTranslations.buttons.select">
        <i class="fas fa-folder-open" aria-hidden="true"></i>
        {{ resolvedTranslations.buttons.select }}
      </button>
      <span class="generic-upload__text" aria-hidden="true">{{ resolvedTranslations.labels.dropFilesHere }}</span>
    </div>
    
    <div *ngIf="restrictions.allowedExtensions?.length || restrictions.maxFileSize" class="generic-upload__restrictions" role="note">
      <small class="generic-upload__restrictions-text">
        <span *ngIf="restrictions.allowedExtensions?.length">
          {{ resolvedTranslations.labels.allowedTypes }}: {{ restrictions.allowedExtensions.join(', ') }}
        </span>
        <span *ngIf="restrictions.maxFileSize && restrictions.allowedExtensions?.length"> | </span>
        <span *ngIf="restrictions.maxFileSize">
          {{ resolvedTranslations.labels.maxSize }}: {{ formatBytes(restrictions.maxFileSize) }}
        </span>
      </small>
    </div>
  </div>

  <div 
    *ngIf="allFilesForDisplay.length > 0" 
    class="generic-upload__file-list"
    role="list"
    [attr.aria-label]="resolvedTranslations.labels.uploadedFiles">
    <div
      *ngFor="let file of allFilesForDisplay"
      class="generic-upload__file-item"
      [class.generic-upload__file-item--uploading]="file.state === UploadFileState.Uploading"
      [class.generic-upload__file-item--completed]="file.state === UploadFileState.Completed"
      [class.generic-upload__file-item--failed]="file.state === UploadFileState.Failed"
      role="listitem">
      
      <i
        class="fas generic-upload__file-icon"
        [class.fa-file]="file.state === UploadFileState.Pending"
        [class.fa-spinner]="file.state === UploadFileState.Uploading"
        [class.fa-spin]="file.state === UploadFileState.Uploading"
        [class.fa-check-circle]="file.state === UploadFileState.Completed"
        [class.fa-exclamation-circle]="file.state === UploadFileState.Failed"
        [attr.aria-label]="getFileStateLabel(file.state)"
        role="img">
      </i>
      
      <div class="generic-upload__file-details">
        <div class="generic-upload__file-name" [title]="file.name">{{ file.name }}</div>
        <div class="generic-upload__file-size">{{ file.getSizeFormattedWithUnit(resolvedTranslations.units) }}</div>
        <small 
          *ngIf="file.errorMessage" 
          class="generic-upload__error-message"
          role="alert"
          [attr.aria-live]="'assertive'">{{ file.errorMessage }}</small>
      </div>

      <div 
        *ngIf="file.state === UploadFileState.Uploading" 
        class="generic-upload__progress"
        role="progressbar"
        [attr.aria-valuenow]="file.progress"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100"
        [attr.aria-label]="resolvedTranslations.labels.uploadProgress">
        <div class="generic-upload__progress-bar">
          <div class="generic-upload__progress-fill" [style.width.%]="file.progress"></div>
        </div>
        <span class="generic-upload__progress-text" aria-hidden="true">{{ file.progress }}%</span>
      </div>

      <button
        *ngIf="showRetryButton && file.state === UploadFileState.Failed"
        type="button"
        class="generic-button generic-button-link generic-button-sm generic-upload__action-btn"
        (click)="retryFile(file)"
        [attr.aria-label]="resolvedTranslations.buttons.retry + ' ' + file.name">
        <i class="fas fa-redo" aria-hidden="true"></i>
      </button>
      
      <button
        *ngIf="showRemoveButton"
        type="button"
        class="generic-button generic-button-link generic-button-sm generic-upload__action-btn generic-upload__action-btn--remove"
        (click)="removeFile(file)"
        [attr.aria-label]="resolvedTranslations.buttons.remove + ' ' + file.name">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>
